module.exports = __webpack_public_path__ + "static/media/img-01.128f6712.jpg";